import { render, staticRenderFns } from "./SchulhausIcon.vue?vue&type=template&id=d979143e"
import script from "./SchulhausIcon.vue?vue&type=script&lang=js"
export * from "./SchulhausIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports